import { MDBBtn, MDBIcon } from 'mdb-react-ui-kit';
import { CSSProperties, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { machinePowerStatus } from '../service/status';
import { OpMachineDTO, OpMachineListItemDTO } from '@scm/common-legacy';

export interface MachinePowerButtonProps {
    machine: OpMachineDTO | OpMachineListItemDTO;
    size?:
        | 'lg'
        | '1x'
        | '2x'
        | '3x'
        | '4x'
        | '5x'
        | '6x'
        | '7x'
        | '8x'
        | '9x'
        | '10x'
        | '2xs'
        | 'xs'
        | 'sm'
        | 'xl'
        | '2xl';
    tooltipId?: string;
    className?: string;
    onClick?: () => void;
    style?: CSSProperties;
}

export const MachinePowerButton = ({
    machine,
    size,
    className,
    onClick,
    style,
}: MachinePowerButtonProps) => {
    const { t } = useTranslation();

    const { title, bg, icon } = useMemo(
        () => machinePowerStatus(machine?.power),
        [machine],
    );

    return (
        <div>
            <MDBBtn
                tag={onClick ? 'a' : 'span'}
                color="none"
                className={className}
                // data-tooltip-id={tooltipId || "machine-power-button"}
                // data-tooltip-content={t(`status:${title}`)}
                title={t(`status:${title}`)}
                onClick={onClick}
                style={style}
            >
                <MDBBtn
                    tag="span"
                    floating
                    size="sm"
                    className={`d-flex bg-${bg} shadow-0 align-items-center`}
                >
                    <MDBIcon icon={icon} color="white" size={size} />
                </MDBBtn>
            </MDBBtn>
            {/* <Tooltip id={tooltipId || "machine-power-button"} place="top" style={{zIndex: 9999}}/> */}
        </div>
    );
};
